import React, { useState } from 'react'
import { Collapse } from '@material-ui/core/'
import EditSvg from '../../../../assets/images/edit.svg'
import DeleteSvg from '../../../../assets/images/delete.svg'
import ArrowSvg from '../../../../assets/images/down-arrow.svg'

import './Item.scss'

function Item ({ children, details, onClickEdit, onClickDelete, isFetching, fetchPlaces, ubicationId }) {

  const [showDetails, setShowDetails] = useState(false)

  const fetchDetails = () => {
    if(!isFetching || showDetails) {
      setShowDetails(!showDetails)
    } else {
      fetchPlaces(ubicationId)
      setShowDetails(!showDetails)
    }
  }

  return (
    <div className='item-container'>
      <div className='item-header' style={showDetails ? { border: 'none'} : null}>
        <div className='child-container'>
          {children}
        </div>
        <div className='item-buttons'>
          <div className='edit-container' onClick={onClickEdit}>
            <img src={EditSvg} alt='editar'/>
          </div>
          <div className='delete-container' onClick={onClickDelete}>
            <img src={DeleteSvg} alt='eliminar'/>
          </div>
          {
            details ? (
              <div className={`arrow-container ${showDetails ? 'up' : null}`} onClick={() => fetchDetails()}><img src={ArrowSvg} alt='desplegar' /></div>
            ) : null
          }
        </div>
      </div>
      <Collapse in={showDetails}>
        <div className='item-details'>
          {details}
        </div>
      </Collapse>
    </div>
  )

}

export default Item
